import React from "react"
import "./floatingContact.scss"
import qrCode from "../../misc/qrCode.jpg"
import { Grid } from '@mui/material/';
import { useTranslation } from 'react-i18next';
import SETTINGS from "../../utils/constants";
import '../../utils/common.scss'

const FloatingContact=()=>{
  const {t, i18n} = useTranslation()
  const isChinese = i18n.language === 'cn'
  return(
    <div className="floatingContainer general-text" style={{color: SETTINGS.DEEP_COLOR}}>
      {isChinese?
        <Grid container direction="column" sx={{visibility: {xs: 'hidden', sm: 'visible'}, maxWidth: '200px'}}>
          <Grid item>
            {t('floatingContact.wechatLabel')}
          </Grid>
          <Grid item>
            <img src={qrCode} style={{maxWidth: '200px'}} alt="qrCode" />
          </Grid>
          <Grid item>
            {t('floatingContact.callLabel')}
          </Grid>
          <Grid item>
            {t('floatingContact.phone')}
          </Grid>
        </Grid>
        :
        <Grid container direction="column" sx={{visibility: {xs: 'hidden', sm: 'visible'}, maxWidth: '200px'}} alignItems="center">
          <Grid item>
            {t('floatingContact.bookOnline')}
          </Grid>
          <Grid item sx={{margin: '10px 0px'}}>
            <iframe
              title="Jane App Book Online"
              src={SETTINGS.JANE_BOOKING_EMBED}
              frameBorder="0"
              scrolling="no"
              width="177"
              height="28"
            />
          </Grid>
          <Grid item>
            {t('floatingContact.callLabel')}
          </Grid>
          <Grid item>
            {t('floatingContact.phone')}
          </Grid>
        </Grid>
      }
    </div>
  )
}

export default FloatingContact
